var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9954 31.0434C30.9954 31.9409 30.2678 32.6684 29.3704 32.6684L15.5818 32.6684C14.6843 32.6684 13.9568 31.9409 13.9568 31.0434L13.9568 17.2548C13.9568 16.3573 14.6843 15.6298 15.5818 15.6298C16.4792 15.6298 17.2068 16.3573 17.2068 17.2548L17.2068 27.1203L30.5194 13.8077C31.154 13.1731 32.1829 13.1731 32.8175 13.8077C33.4521 14.4423 33.4521 15.4712 32.8175 16.1058L19.5049 29.4184L29.3704 29.4184C30.2678 29.4184 30.9954 30.1459 30.9954 31.0434Z",
    fill: "#3AB44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f7c40a901ef67895a62923c95c528cda.svg";
export { ForwardRef as ReactComponent };